import CommonKiosque from "./../../../common/components/kiosque";
import kiosque from "./../templates/kiosque.dust";
import publicationList from "./../templates/publicationList.dust";
import language from "./../../../common/dictionary";
import PreferredViewerSwitcher from "./../../../common/components/preferredViewerSwitcher";

import PublicationList from "./publicationList";
import PublicationListSwiper from "./publicationListSwiper";

import {
  SWIPED_ARCHIVE_HOME,
  SWIPED_PROMOSPOT_HOME,
  SWIPED_SPECIALS_HOME,
  CLICKED_ARROW_ARCHIVE_HOME,
  CLICKED_ARROW_PROMOSPOT_HOME,
  CLICKED_ARROW_SPECIALS_HOME,
  CLICKED_ARCHIVE_HOME,
  CLICKED_PROMOSPOT_HOME,
  CLICKED_SPECIALS_HOME,
  CLICKED_NEWSSTAND,
  CLICKED_NEXTGEN_READING_MODE_HOME,
  CLICKED_REPLICA_READING_MODE_HOME,
} from "./../../../common/analytics/analyticsevents";

/**
 * Contstructs the Kiosque view
 */
export default class Kiosque extends CommonKiosque {
  constructor(appState, DOMContainer, options) {
    super(appState, DOMContainer, kiosque, options);
  }

  attatchClickHandlers() {}

  renderDone() {
    if (this.options.displayViewerOptions) {
      const preferredViewerSwitcher = new PreferredViewerSwitcher(
        this.appState,
        document.getElementById("preferred-viewer-box")
      );
      preferredViewerSwitcher.on(
        "readingModeSwitcher:clicked",
        this.onReadingModeChanged
      );
      preferredViewerSwitcher.render();
    }
  }

  setArchive(contentPackages) {
    this.setPublicationList(
      "archive",
      language.Archive,
      contentPackages,
      CLICKED_ARCHIVE_HOME,
      SWIPED_ARCHIVE_HOME,
      CLICKED_ARROW_ARCHIVE_HOME,
      this.options.useSlider.useSliderForArchive
    ).then(() => {
      this.appState.triggerEvent(
        "archive:loaded",
        this.appState._downloadToken
      );
    });
  }

  setPromospot(contentPackages) {
    if (this.options.usePromoSpot) {
      this.setPublicationList(
        "promoSpot",
        language.Promospot,
        contentPackages,
        CLICKED_PROMOSPOT_HOME,
        SWIPED_PROMOSPOT_HOME,
        CLICKED_ARROW_PROMOSPOT_HOME,
        this.options.useSlider.useSliderForPromospot
      );
    }
  }

  setHorsseries(contentPackages) {
    if (this.options.displayHorsSerieArchive) {
      this.setPublicationList(
        "horsserie",
        language.HorsSeries,
        contentPackages,
        CLICKED_SPECIALS_HOME,
        SWIPED_SPECIALS_HOME,
        CLICKED_ARROW_SPECIALS_HOME,
        this.options.useSlider.useSliderForHorsSeries
      );
    }
  }

  setPublicationList(
    name,
    titleName,
    contentPackages,
    clickedEvent,
    swipedEvent,
    arrowEvent,
    swiper = false
  ) {
    if (this.DOMContent) {
      let publicationList;
      if (swiper) {
        publicationList = new PublicationListSwiper(
          this.appState,
          this.DOMContent,
          name,
          titleName,
          contentPackages,
          clickedEvent,
          swipedEvent,
          arrowEvent
        );
      } else {
        publicationList = new PublicationList(
          this.appState,
          this.DOMContent,
          name,
          titleName,
          contentPackages,
          clickedEvent
        );
      }

      publicationList.on("publicationList:onPublicationClicked", (e) => {
        this.onPublicationClick(e);
      });
      return publicationList.render();
    } else {
      // FIXME The timeout existed before i wrapped the promise around it, please forgive me
      return new Promise((resolve) => {
        setTimeout(() => {
          this.setPublicationList(
            name,
            titleName,
            contentPackages,
            clickedEvent,
            swipedEvent,
            arrowEvent,
            swiper
          ).then(() => {
            resolve();
          });
        }, 100);
      });
    }
  }

  setNewsstandRedirecting(packages) {
    if (this.DOMContent) {
      if (packages.length === 0) {
        return;
      }
      const container = this.DOMContent.querySelector("#newsStand");
      if (container) {
        const context = {};
        context.contentPackages = packages;
        context.name = "newsstand";
        context.titleName = language.NewsStand;
        Dust.render(publicationList, context, (err, result) => {
          container.innerHTML = result;
          $(container).on("click", ".thumb-wrapper", (e) => {
            window.location = $(e.currentTarget).data("url");
            this.appState.triggerEvent(CLICKED_NEWSSTAND);
          });
        });
      }
    } else {
      setTimeout(() => {
        this.setNewsstandRedirecting(packages);
      }, 100);
    }
  }

  onReadingModeChanged = (readingModeType) => {
    if (readingModeType === "nextgen") {
      this.appState.triggerEvent(CLICKED_NEXTGEN_READING_MODE_HOME);
    } else {
      this.appState.triggerEvent(CLICKED_REPLICA_READING_MODE_HOME);
    }
  };
}



// WEBPACK FOOTER //
// ./src/web/home/components/kiosque.js